var _path, _g, _g2, _g3, _path2, _rect, _path3, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 323.215,
    height: 261.952,
    viewBox: "0 0 323.215 261.952",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1862",
    "data-name": "Grupo 1862",
    transform: "translate(-99.148 -614.475)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1919",
    "data-name": "Trazado 1919",
    d: "M422.363,975.247c0,4.736-9.244,9.8-153.866,9.8S99.148,981.2,99.148,976.464s24.736-8.579,169.349-8.579S422.363,970.506,422.363,975.247Z",
    transform: "translate(0 -108.615)",
    fill: "#acbfe2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1849",
    "data-name": "Grupo 1849",
    transform: "translate(113.554 614.475)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1848",
    "data-name": "Grupo 1848"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1920",
    "data-name": "Trazado 1920",
    d: "M337.318,837.549A11.5,11.5,0,0,1,326.1,849.327H222.952a11.508,11.508,0,0,1-11.225-11.778V662.676a11.505,11.505,0,0,1,11.225-11.768H326.1a11.5,11.5,0,0,1,11.216,11.768Z",
    transform: "translate(-148.154 -625.672)",
    fill: "#dee0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1921",
    "data-name": "Trazado 1921",
    d: "M315.97,875.4a12.534,12.534,0,0,1-12.552,12.527H188.011A12.533,12.533,0,0,1,175.468,875.4V689.33a12.543,12.543,0,0,1,12.543-12.54H303.418a12.545,12.545,0,0,1,12.552,12.54Z",
    transform: "translate(-137.01 -633.627)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1922",
    "data-name": "Trazado 1922",
    d: "M277.709,627.426H207.361c-4.561-7.52-9.54-12.951-14.412-12.951H131.723a11.77,11.77,0,0,0-11.777,11.772V851.594a11.774,11.774,0,0,0,11.777,11.768H277.709a11.772,11.772,0,0,0,11.774-11.768V639.2A11.773,11.773,0,0,0,277.709,627.426Z",
    transform: "translate(-119.946 -614.475)",
    fill: "#0387d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1923",
    "data-name": "Trazado 1923",
    d: "M119.946,626.282V851.629a11.739,11.739,0,0,0,10.988,11.689V614.59A11.735,11.735,0,0,0,119.946,626.282Z",
    transform: "translate(-119.946 -614.51)",
    fill: "#001b70"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1924",
    "data-name": "Trazado 1924",
    d: "M217.149,868.9l99.723-2.916,39.651-43.9L352.061,669.23a12.341,12.341,0,0,0-12.694-11.974l-128.288,3.749A12.333,12.333,0,0,0,199.1,673.7l5.351,183.224A12.345,12.345,0,0,0,217.149,868.9Z",
    transform: "translate(-144.271 -627.621)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1925",
    "data-name": "Trazado 1925",
    d: "M339.608,783.776l-105.665,4.057-.322-8.535,105.652-4.066Z",
    transform: "translate(-154.882 -663.881)",
    fill: "#d7d4ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2901",
    "data-name": "Rect\\xE1ngulo 2901",
    width: 105.735,
    height: 8.542,
    transform: "translate(77 97.725) rotate(-2.206)",
    fill: "#d7d4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1926",
    "data-name": "Trazado 1926",
    d: "M366.317,731.465,320.849,733.5l-.322-8.547,45.455-2.029Z",
    transform: "translate(-181.591 -647.806)",
    fill: "#d7d4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1927",
    "data-name": "Trazado 1927",
    d: "M366.317,704.7l-45.469,2.038-.322-8.547,45.455-2.029Z",
    transform: "translate(-181.591 -639.581)",
    fill: "#d7d4ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2902",
    "data-name": "Rect\\xE1ngulo 2902",
    width: 105.741,
    height: 8.55,
    transform: "matrix(0.999, -0.038, 0.038, 0.999, 79.426, 133.307)",
    fill: "#d7d4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1928",
    "data-name": "Trazado 1928",
    d: "M341.6,835.436l-105.665,4.056-.323-8.532L341.265,826.9Z",
    transform: "translate(-155.494 -679.76)",
    fill: "#d7d4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1929",
    "data-name": "Trazado 1929",
    d: "M342.58,861.256l-105.659,4.065-.331-8.544,105.664-4.059Z",
    transform: "translate(-155.795 -687.695)",
    fill: "#d7d4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1930",
    "data-name": "Trazado 1930",
    d: "M343.583,887.081l-105.661,4.06-.329-8.535,105.665-4.069Z",
    transform: "translate(-156.103 -695.631)",
    fill: "#d7d4ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2903",
    "data-name": "Rect\\xE1ngulo 2903",
    width: 105.732,
    height: 8.544,
    transform: "translate(82.183 204.866) rotate(-2.204)",
    fill: "#d7d4ff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1854",
    "data-name": "Grupo 1854",
    transform: "translate(254.966 690.481)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1850",
    "data-name": "Grupo 1850"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1931",
    "data-name": "Trazado 1931",
    d: "M440.921,724.205H358.09L324.1,759.674V886.646A10.249,10.249,0,0,0,334.353,896.9H440.921a10.246,10.246,0,0,0,10.242-10.251V734.45A10.241,10.241,0,0,0,440.921,724.205Z",
    transform: "translate(-324.102 -724.205)",
    fill: "#c9d8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1932",
    "data-name": "Trazado 1932",
    d: "M358.09,724.205,324.1,759.674v1h24.6a10.244,10.244,0,0,0,10.238-10.249V724.205Z",
    transform: "translate(-324.102 -724.205)",
    fill: "#7585f8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1851",
    "data-name": "Grupo 1851",
    transform: "translate(11.996 48.479)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2904",
    "data-name": "Rect\\xE1ngulo 2904",
    width: 86.106,
    height: 6.956,
    fill: "#b2d2ea"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2905",
    "data-name": "Rect\\xE1ngulo 2905",
    width: 86.106,
    height: 6.961,
    transform: "translate(0 14.58)",
    fill: "#b2d2ea"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2906",
    "data-name": "Rect\\xE1ngulo 2906",
    width: 86.106,
    height: 6.96,
    transform: "translate(0 29.16)",
    fill: "#b2d2ea"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2907",
    "data-name": "Rect\\xE1ngulo 2907",
    width: 86.106,
    height: 6.958,
    transform: "translate(0 43.738)",
    fill: "#b2d2ea"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2908",
    "data-name": "Rect\\xE1ngulo 2908",
    width: 86.106,
    height: 6.961,
    transform: "translate(0 58.323)",
    fill: "#b2d2ea"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2909",
    "data-name": "Rect\\xE1ngulo 2909",
    width: 86.106,
    height: 6.966,
    transform: "translate(0 72.896)",
    fill: "#b2d2ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1852",
    "data-name": "Grupo 1852",
    transform: "translate(32.794 21.027)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1933",
    "data-name": "Trazado 1933",
    d: "M474.517,754.561H401.436l-29.99,31.308V897.9a9.041,9.041,0,0,0,9.044,9.036h94.026a9.039,9.039,0,0,0,9.042-9.036v-134.3A9.044,9.044,0,0,0,474.517,754.561Z",
    transform: "translate(-371.446 -754.561)",
    fill: "#d3ddf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1934",
    "data-name": "Trazado 1934",
    d: "M401.436,754.561l-29.99,31.308v.875h21.707a9.034,9.034,0,0,0,9.032-9.037V754.561Z",
    transform: "translate(-371.446 -754.561)",
    fill: "#7585f8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1853",
    "data-name": "Grupo 1853",
    transform: "translate(53 65.985)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2910",
    "data-name": "Rect\\xE1ngulo 2910",
    width: 70.109,
    height: 6.956,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2911",
    "data-name": "Rect\\xE1ngulo 2911",
    width: 70.109,
    height: 6.959,
    transform: "translate(0 14.58)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2912",
    "data-name": "Rect\\xE1ngulo 2912",
    width: 70.109,
    height: 6.954,
    transform: "translate(0 29.164)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2913",
    "data-name": "Rect\\xE1ngulo 2913",
    width: 70.109,
    height: 6.961,
    transform: "translate(0 43.736)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2914",
    "data-name": "Rect\\xE1ngulo 2914",
    width: 70.109,
    height: 6.961,
    transform: "translate(0 58.321)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2915",
    "data-name": "Rect\\xE1ngulo 2915",
    width: 70.109,
    height: 6.963,
    transform: "translate(0 72.896)",
    fill: "#fff"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1859",
    "data-name": "Grupo 1859",
    transform: "translate(305.05 749.644)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1855",
    "data-name": "Grupo 1855",
    transform: "translate(18.611 11.719)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1935",
    "data-name": "Trazado 1935",
    d: "M430.084,828.425s-3.817-3.208-6.316-1.261c-2.189,1.719,3.622.062,4.3,2.683Z",
    transform: "translate(-423.277 -826.537)",
    fill: "#ffaa83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1936",
    "data-name": "Trazado 1936",
    d: "M457.444,839.691c3.031,3.576,1.307,6.235-1.18,7.209-3.949,1.565-12.322,6.139-14.946,4.11s-11.634-20.762-11.634-20.762a1.757,1.757,0,0,1,2.368-1.06l12.487,14.2S454.579,836.3,457.444,839.691Z",
    transform: "translate(-425.247 -827.301)",
    fill: "#b2d2ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1856",
    "data-name": "Grupo 1856",
    transform: "translate(48.476 114.08)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1937",
    "data-name": "Trazado 1937",
    d: "M468.885,979.347c1.816-1.323,1.8-1.593,1.525-2.2a13.127,13.127,0,0,0-.908-1.6l3.6-1.232a16.034,16.034,0,0,1,.693,3.382C473.486,977.955,471.074,980,468.885,979.347Z",
    transform: "translate(-467.159 -974.315)",
    fill: "#ee9d7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1938",
    "data-name": "Trazado 1938",
    d: "M473.03,979.175a.691.691,0,0,1,.047-.053c1.208,3.089-3.26,3.771-5.748,3.593s.79-1.89.79-1.89C470.308,981.478,472.721,979.432,473.03,979.175Z",
    transform: "translate(-466.394 -975.792)",
    fill: "#ec364f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1939",
    "data-name": "Trazado 1939",
    d: "M441.007,885.545s-.447,7.347.474,11.8c3.093,14.947,4.1,13.267,5.249,17.387,1.927,7.008,7.433,24.338,14.178,33.222.8,1.041,4.784-.686,4.7-2.329-.515-10.99-.573-15.936-5.093-27.178,0,0,2.671-9.151,2.79-13.534.138-5.176-.127-17.531-3.649-22.758Z",
    transform: "translate(-410.082 -831.911)",
    fill: "#001b70"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1857",
    "data-name": "Grupo 1857",
    transform: "translate(26.815 116.264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1940",
    "data-name": "Trazado 1940",
    d: "M438,981.49c2.062-.912,2.115-1.18,1.972-1.838a14.8,14.8,0,0,0-.551-1.743l3.771-.441a15.285,15.285,0,0,1-.041,3.454C442.808,981.109,440.013,982.6,438,981.49Z",
    transform: "translate(-436.007 -977.468)",
    fill: "#ee9d7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1941",
    "data-name": "Trazado 1941",
    d: "M442.267,982.438a.288.288,0,0,1,.064-.038c.528,3.277-3.984,2.984-6.378,2.282s1.163-1.676,1.163-1.676C439.128,984.114,441.923,982.624,442.267,982.438Z",
    transform: "translate(-435.122 -978.984)",
    fill: "#ec364f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1942",
    "data-name": "Trazado 1942",
    d: "M429.936,884.993s-1.988,7.087-2.034,11.632c-.143,15.259,1.2,13.832,1.444,18.1.4,7.258,2.1,25.362,6.815,35.473.553,1.184,4.824.337,5.094-1.284,1.816-10.842,2.814-15.685.778-27.639,0,0,4.55-8.371,5.593-12.634,1.222-5.022,3.595-17.153,1.25-23.021Z",
    transform: "translate(-406.085 -832.783)",
    fill: "#001b70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1943",
    "data-name": "Trazado 1943",
    d: "M438.206,839.878c-3.666,2.806-6.774,9.624-8.239,31.94-.323,4.9,28.142,6.084,28.245,1.162.252-13.088-1.984-18.471-5.731-30.272C451.462,839.5,445.456,834.287,438.206,839.878Z",
    transform: "translate(-406.722 -818.16)",
    fill: "#fcdcda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1944",
    "data-name": "Trazado 1944",
    d: "M431.112,857.049s-6.037,23.705-6.037,36.174v20.538s22.356,4.741,35.506-4.476c0,0-.971-32.938-5.16-45.529Z",
    transform: "translate(-405.219 -824.195)",
    fill: "#ebf2f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1858",
    "data-name": "Grupo 1858",
    transform: "translate(0 16.208)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1945",
    "data-name": "Trazado 1945",
    d: "M399.62,837.459s-1.365-6.285-2.212-3.9-2.034,2.84.716,5.776Z",
    transform: "translate(-396.409 -833.018)",
    fill: "#ffaa83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1946",
    "data-name": "Trazado 1946",
    d: "M430.573,841.495c4.177,2.746,2.986,6.116.549,7.977-3.862,2.98-11.734,10.609-15.088,9.358S398.2,840.906,398.2,840.906a2.122,2.122,0,0,1,2.282-1.9l17.088,10.729S426.606,838.894,430.573,841.495Z",
    transform: "translate(-396.961 -834.854)",
    fill: "#b2d2ea"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1947",
    "data-name": "Trazado 1947",
    d: "M441.216,809.815c-3.065.414-6.846,2.951-6.812,9.014s-.127,6.173-2.132,8.408c-5.18,5.748,8.509,5.092,5.02,11.031-9.65,16.39,14.809,13.535,19.437,8.613,5.216-5.557,6.9-14.818.815-18.79-2.005-1.308,1.558-8.45-3.305-9.816S453.021,808.211,441.216,809.815Z",
    transform: "translate(-407.066 -809.618)",
    fill: "#353a66"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1948",
    "data-name": "Trazado 1948",
    d: "M273.695,696.031c1.9,3.783,3.835,7.548,5.683,11.356a32.916,32.916,0,0,1,2.207,5.329c.679,2.4-.08,3.938-1.667,4.909a9.349,9.349,0,0,1-3.707,1.25c-.071.01-.142.024-.213.033a3.9,3.9,0,0,1-4.387-2.275,5.091,5.091,0,0,1-.726-3.3,7.863,7.863,0,0,0,.053-.86,1.629,1.629,0,0,0-.776-1.649,3.281,3.281,0,0,1-1.463-2.908,1.594,1.594,0,0,1,0-.269,2.364,2.364,0,0,0-.95-2.564,2.773,2.773,0,0,1-.848-2.408,25.409,25.409,0,0,0-.159-2.886,1.424,1.424,0,0,0-.526-.953,4.993,4.993,0,0,1-1.867-2.483,6.021,6.021,0,0,0-5.7-3.826,9.536,9.536,0,0,0-3.555.483,5.541,5.541,0,0,0-3.616,4.371,7.679,7.679,0,0,1-1.18,2.923,9.835,9.835,0,0,0-.66,1.175,2.638,2.638,0,0,0-.255,1.882,12.242,12.242,0,0,1,.233,1.435,2.982,2.982,0,0,1-.711,2.408,2.75,2.75,0,0,0-.654,2.2,22.546,22.546,0,0,1,.1,2.258,3.211,3.211,0,0,1-.81,2.124c-.235.271-.427.577-.645.863a2.087,2.087,0,0,0-.44,1.771,7.37,7.37,0,0,1-.519,3.911,2.936,2.936,0,0,1-2.408,2.084,8.977,8.977,0,0,1-4.778-.461,2.79,2.79,0,0,1-1.807-2.277,16.946,16.946,0,0,1,.287-6.353,95.415,95.415,0,0,1,4.138-14.707,6.23,6.23,0,0,1,1.489-2.531,3.936,3.936,0,0,0,.686-1.2c.436-.927.81-1.883,1.278-2.793a3.04,3.04,0,0,1,1.516-1.478,1.6,1.6,0,0,0,.543-.508c.268-.338.5-.7.757-1.051a4.057,4.057,0,0,1,2.437-1.663,2.237,2.237,0,0,0,.792-.4,6.824,6.824,0,0,1,5.911-1.4,2.045,2.045,0,0,0,1.039-.057,8.5,8.5,0,0,1,4.995-.006,3.617,3.617,0,0,1,.577.288,14.314,14.314,0,0,0,1.587.765,3.747,3.747,0,0,1,2.135,1.709,1.934,1.934,0,0,0,.7.711,10.96,10.96,0,0,1,4.73,4.943l1.038,2.135Zm3.851,9.769.14-.069c-1.836-3.575-3.693-7.139-5.5-10.728a11.406,11.406,0,0,0-4.969-5.356,1.91,1.91,0,0,1-.772-.8,3.045,3.045,0,0,0-1.933-1.514,11.347,11.347,0,0,1-1.488-.727,3.016,3.016,0,0,0-.573-.294,7.677,7.677,0,0,0-4.409.057,2.568,2.568,0,0,1-1.364.075,5.987,5.987,0,0,0-5.339,1.272,2.461,2.461,0,0,1-.939.474,3.481,3.481,0,0,0-2.2,1.531c-.244.355-.482.717-.756,1.049a5.7,5.7,0,0,1-.632.577,5.434,5.434,0,0,0-1.155,1.06c-.493.829-.833,1.749-1.261,2.619a6.71,6.71,0,0,1-.941,1.671,6.108,6.108,0,0,0-1.288,2.212,94.3,94.3,0,0,0-3.943,13.811c-.438,2.3-.946,4.574-.423,6.936a1.816,1.816,0,0,0,1.083,1.42,7.588,7.588,0,0,0,4.805.421,1.542,1.542,0,0,0,.8-.5,5.306,5.306,0,0,0,1.124-4.084,3.893,3.893,0,0,1,1.015-3.319,3.406,3.406,0,0,0,.873-2.841c-.046-.427-.033-.862-.091-1.288a3.363,3.363,0,0,1,.8-2.762,2.341,2.341,0,0,0,.544-1.91c-.053-.409-.123-.816-.209-1.219a3.385,3.385,0,0,1,.236-2.264,15.878,15.878,0,0,1,.858-1.557,6.277,6.277,0,0,0,.926-2.222,6.428,6.428,0,0,1,4.788-5.483,9.351,9.351,0,0,1,5.737.069,6.936,6.936,0,0,1,4.2,4.295,2.7,2.7,0,0,0,1.235,1.57,2.272,2.272,0,0,1,1.018,1.465,8.289,8.289,0,0,1,.212,3.154,2.482,2.482,0,0,0,1.087,2.372,1.687,1.687,0,0,1,.736,1.635c-.017.2-.018.4-.034.593a3.054,3.054,0,0,0,1.424,3.193,1.825,1.825,0,0,1,.8,1.625,5.007,5.007,0,0,1-.032,1.184,4.666,4.666,0,0,0,.727,3.236,2.962,2.962,0,0,0,3.165,1.645,9.194,9.194,0,0,0,3.742-1.129,2.892,2.892,0,0,0,1.554-2.487,6.005,6.005,0,0,0-.631-2.975C279.408,709.583,278.468,707.7,277.546,705.8Z",
    transform: "translate(-42.291 -21.725)",
    fill: "#001b70"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1861",
    "data-name": "Grupo 1861",
    transform: "translate(218.396 677.457)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2916",
    "data-name": "Rect\\xE1ngulo 2916",
    width: 7.099,
    height: 28.092,
    transform: "translate(47.302 49.627) rotate(-50.36)",
    fill: "#6fbbe9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_2917",
    "data-name": "Rect\\xE1ngulo 2917",
    d: "M6.119,0h0a6.119,6.119,0,0,1,6.119,6.119V49.537a6.119,6.119,0,0,1-6.119,6.119h0A6.118,6.118,0,0,1,0,49.537V6.119A6.119,6.119,0,0,1,6.119,0Z",
    transform: "matrix(0.638, -0.77, 0.77, 0.638, 60.576, 63.96)",
    fill: "#66adff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_712",
    "data-name": "Elipse 712",
    cx: 29.308,
    cy: 29.308,
    r: 29.308,
    transform: "matrix(0.995, -0.1, 0.1, 0.995, 1.885, 7.761)",
    fill: "#6fbbe9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1860",
    "data-name": "Grupo 1860",
    transform: "translate(0 0)"
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_713",
    "data-name": "Elipse 713",
    cx: 24.03,
    cy: 24.03,
    r: 24.03,
    transform: "translate(0 33.983) rotate(-45)",
    fill: "#e6f3f9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1949",
    "data-name": "Trazado 1949",
    d: "M314.25,767.991q-2.236-23.839-4.473-47.677a23.95,23.95,0,0,0-10.2,4.417l3.83,40.816A23.94,23.94,0,0,0,314.25,767.991Z",
    transform: "translate(-279.996 -709.985)",
    fill: "#e6f3f9",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1950",
    "data-name": "Trazado 1950",
    d: "M334.315,764.2q-2-21.351-4.006-42.7a23.95,23.95,0,0,0-6.207-1.525q2.2,23.44,4.4,46.88A23.931,23.931,0,0,0,334.315,764.2Z",
    transform: "translate(-287.532 -709.881)",
    fill: "#e6f3f9",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.8625a79db2870984d15bc55101ba2b86.svg";
export { ForwardRef as ReactComponent };